import { render, staticRenderFns } from "./ReservationsStart.vue?vue&type=template&id=054864fa&scoped=true"
import script from "./ReservationsStart.vue?vue&type=script&lang=js"
export * from "./ReservationsStart.vue?vue&type=script&lang=js"
import style0 from "./ReservationsStart.vue?vue&type=style&index=0&id=054864fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054864fa",
  null
  
)

export default component.exports